export const storeToFixtureSetsMap = new Map<string, Set<string>[]>([
  [
    'MX-MENDEL-TST-01',
    [
      new Set([
        'row23.table14',
        'row23.table13',
        'row23.table12',
        'row23.table11',
        'row23.table10',
        'row23.table9',
        'row23.table8',
        'row23.table7',
        'row23.table6',
        'row23.table5',
      ]),
      new Set(['row22.table18', 'row22.table19', 'row22.table20', 'row22.table21', 'row22.table22']),
      new Set(['row22.table15', 'row22.table14', 'row22.table13', 'row22.table12', 'row22.table11']),
      new Set(['row23.table4', 'row23.table3', 'row23.table2', 'row23.table1']),
      new Set(['row22.table5', 'row22.table6', 'row22.table7', 'row22.table8']),
      new Set(['row22.table4', 'row22.table3', 'row22.table2', 'row22.table1']),
    ],
  ],
  [
    'US-WA-34',
    [
      new Set([
        'row23.table14',
        'row23.table13',
        'row23.table12',
        'row23.table11',
        'row23.table10',
        'row23.table9',
        'row23.table8',
        'row23.table7',
        'row23.table6',
        'row23.table5',
      ]),
      new Set(['row22.table18', 'row22.table19', 'row22.table20', 'row22.table21', 'row22.table22']),
      new Set(['row22.table15', 'row22.table14', 'row22.table13', 'row22.table12', 'row22.table11']),
      new Set(['row23.table4', 'row23.table3', 'row23.table2', 'row23.table1']),
      new Set(['row22.table5', 'row22.table6', 'row22.table7', 'row22.table8']),
      new Set(['row22.table4', 'row22.table3', 'row22.table2', 'row22.table1']),
    ],
  ],
  [
    'MENDEL-TST-02',
    [
      new Set(['row36.table48', 'row36.table47', 'row36.table46', 'row36.table45']),
      new Set(['row36.table41', 'row36.table42', 'row36.table43', 'row36.table44']),
      new Set(['row36.table38', 'row36.table37', 'row36.table36', 'row36.table35']),
      new Set(['row36.table31', 'row36.table32', 'row36.table33', 'row36.table34']),
      new Set(['row36.table28', 'row36.table27', 'row36.table26', 'row36.table25']),
      new Set(['row36.table21', 'row36.table22', 'row36.table23', 'row36.table24']),
      new Set(['row36.table18', 'row36.table17', 'row36.table16', 'row36.table15']),
      new Set(['row36.table11', 'row36.table12', 'row36.table13', 'row36.table14']),
    ],
  ],
  [
    'US-CA-118',
    [
      new Set(['row36.table48', 'row36.table47', 'row36.table46', 'row36.table45']),
      new Set(['row36.table41', 'row36.table42', 'row36.table43', 'row36.table44']),
      new Set(['row36.table38', 'row36.table37', 'row36.table36', 'row36.table35']),
      new Set(['row36.table31', 'row36.table32', 'row36.table33', 'row36.table34']),
      new Set(['row36.table28', 'row36.table27', 'row36.table26', 'row36.table25']),
      new Set(['row36.table21', 'row36.table22', 'row36.table23', 'row36.table24']),
      new Set(['row36.table18', 'row36.table17', 'row36.table16', 'row36.table15']),
      new Set(['row36.table11', 'row36.table12', 'row36.table13', 'row36.table14']),
    ],
  ],
  [
    'US-AZ-3',
    [
      new Set(['row18.table10', 'row18.table9', 'row18.table8', 'row18.table7', 'row18.table6']),
      new Set(['row18.table1', 'row18.table2', 'row18.table3', 'row18.table4', 'row18.table5']),
      new Set(['row17.table1', 'row17.table2', 'row17.table3', 'row17.table4', 'row17.table5', 'row17.table6']),
      new Set(['row17.table12', 'row17.table11', 'row17.table10', 'row17.table9', 'row17.table8']),
      new Set(['row16.table1', 'row16.table2', 'row16.table3', 'row16.table4', 'row16.table5', 'row16.table6']),
    ],
  ],
  [
    'US-CA-133',
    [
      new Set(['row18.table10', 'row18.table9', 'row18.table8', 'row18.table7', 'row18.table6']),
      new Set(['row18.table1', 'row18.table2', 'row18.table3', 'row18.table4', 'row18.table5']),
      new Set(['row17.table1', 'row17.table2', 'row17.table3', 'row17.table4', 'row17.table5', 'row17.table6']),
      new Set(['row17.table12', 'row17.table11', 'row17.table10', 'row17.table9', 'row17.table8']),
      new Set(['row16.table1', 'row16.table2', 'row16.table3', 'row16.table4', 'row16.table5', 'row16.table6']),
    ],
  ],
  [
    'HDNI-TST-UFF-MENDEL',
    [
      new Set(['row28.table40', 'row28.table39']),
      new Set(['row28.table38', 'row28.table37']),
      new Set(['row28.table29', 'row28.table30', 'row28.table31']),
      new Set(['row28.table33', 'row28.table34', 'row28.table35']),
      new Set(['row28.table20', 'row28.table21', 'row28.table22']),
      new Set(['row28.table24', 'row28.table25', 'row28.table26']),
      new Set(['row28.table11', 'row28.table12', 'row28.table13']),
      new Set(['row28.table15', 'row28.table16', 'row28.table17']),
      new Set(['row28.table2', 'row28.table3', 'row28.table4']),
      new Set(['row28.table6', 'row28.table7', 'row28.table8']),
    ],
  ],
  [
    'US-NJ-37',
    [
      new Set(['row28.table40', 'row28.table39']),
      new Set(['row28.table38', 'row28.table37']),
      new Set(['row28.table29', 'row28.table30', 'row28.table31']),
      new Set(['row28.table33', 'row28.table34', 'row28.table35']),
      new Set(['row28.table20', 'row28.table21', 'row28.table22']),
      new Set(['row28.table24', 'row28.table25', 'row28.table26']),
      new Set(['row28.table11', 'row28.table12', 'row28.table13']),
      new Set(['row28.table15', 'row28.table16', 'row28.table17']),
      new Set(['row28.table2', 'row28.table3', 'row28.table4']),
      new Set(['row28.table6', 'row28.table7', 'row28.table8']),
    ],
  ],
  [
    'US-VA-27',
    [
      new Set(['row65.table33', 'row65.table34', 'row65.table35', 'row65.table36']),
      new Set(['row65.table29', 'row65.table30', 'row65.table31', 'row65.table32']),
      new Set(['row65.table24', 'row65.table25', 'row65.table26', 'row65.table27']),
      new Set(['row65.table20', 'row65.table21', 'row65.table22', 'row65.table23']),
      new Set(['row65.table15', 'row65.table16', 'row65.table17', 'row65.table18']),
      new Set(['row65.table11', 'row65.table12', 'row65.table13', 'row65.table14']),
      new Set(['row65.table6', 'row65.table7', 'row65.table8', 'row65.table9']),
      new Set(['row65.table2', 'row65.table3', 'row65.table4', 'row65.table5']),
    ],
  ],
  [
    'US-IL-74',
    [
      new Set(['row59.table2', 'row59.table3', 'row59.table4', 'row59.table5']),
      new Set(['row59.table8', 'row59.table9', 'row59.table10', 'row59.table11']),
      new Set(['row60.table2', 'row60.table3', 'row60.table4', 'row60.table5']),
      new Set(['row60.table8', 'row60.table9', 'row60.table10', 'row60.table11']),
      new Set(['row61.table2', 'row61.table3', 'row61.table4', 'row61.table5']),
      new Set(['row61.table8', 'row61.table9', 'row61.table10', 'row61.table11']),
      new Set(['row62.table2', 'row62.table3', 'row62.table4', 'row62.table5']),
      new Set(['row62.table8', 'row62.table9', 'row62.table10', 'row62.table11']),
    ],
  ],
  [
    'US-MD-18',
    [
      new Set(['row23.table26', 'row23.table27', 'row23.table28', 'row23.table29']),
      new Set(['row23.table38', 'row23.table37', 'row23.table36', 'row23.table35']),
      new Set(['row23.table13', 'row23.table14', 'row23.table15', 'row23.table16']),
      new Set(['row23.table25', 'row23.table24', 'row23.table23', 'row23.table22']),
      new Set(['row23.table1', 'row23.table2', 'row23.table3', 'row23.table4']),
      new Set(['row23.table12', 'row23.table11', 'row23.table10', 'row23.table9']),
    ],
  ],
  [
    'US-PA-22',
    [
      new Set(['row59.table32', 'row59.table33', 'row59.table34', 'row59.table35']),
      new Set(['row59.table31', 'row59.table30', 'row59.table29', 'row59.table28']),
      new Set(['row59.table23', 'row59.table24', 'row59.table25', 'row59.table26']),
      new Set(['row59.table22', 'row59.table21', 'row59.table20', 'row59.table19']),
      new Set(['row59.table14', 'row59.table15', 'row59.table16', 'row59.table17']),
      new Set(['row59.table13', 'row59.table12', 'row59.table11', 'row59.table10']),
      new Set(['row59.table5', 'row59.table6', 'row59.table7', 'row59.table8']),
      new Set(['row59.table4', 'row59.table3', 'row59.table2', 'row59.table1']),
    ],
  ],
  [
    'US-IL-75',
    [
      new Set(['row38.table30', 'row38.table29', 'row38.table28', 'row38.table27', 'row38.table26']),
      new Set(['row38.table32', 'row38.table33', 'row38.table34', 'row38.table35', 'row38.table36']),
      new Set(['row38.table18', 'row38.table17', 'row38.table16', 'row38.table15', 'row38.table14']),
      new Set(['row38.table20', 'row38.table21', 'row38.table22', 'row38.table23', 'row38.table24']),
      new Set(['row38.table6', 'row38.table5', 'row38.table4', 'row38.table3', 'row38.table2']),
      new Set(['row38.table8', 'row38.table9', 'row38.table10', 'row38.table11', 'row38.table12']),
    ],
  ],
  [
    'US-NJ-45',
    [
      new Set(['row49.table35', 'row49.table36', 'row49.table37', 'row49.table38', 'row49.table39']),
      new Set(['row49.table44', 'row49.table43', 'row49.table42', 'row49.table41', 'row49.table40']),
      new Set(['row49.table24', 'row49.table25', 'row49.table26', 'row49.table27', 'row49.table28']),
      new Set(['row49.table33', 'row49.table32', 'row49.table31', 'row49.table30', 'row49.table29']),
      new Set(['row49.table13', 'row49.table14', 'row49.table15', 'row49.table16', 'row49.table17']),
      new Set(['row49.table22', 'row49.table21', 'row49.table20', 'row49.table19', 'row49.table18']),
    ],
  ],
  [
    'US-CA-194',
    [
      new Set(['row50.table10', 'row50.table11', 'row50.table12', 'row50.table13']),
      new Set(['row50.table17', 'row50.table16', 'row50.table15', 'row50.table14']),
      new Set(['row50.table19', 'row50.table20', 'row50.table21', 'row50.table22']),
      new Set(['row50.table26', 'row50.table25', 'row50.table24', 'row50.table23']),
      new Set(['row50.table28', 'row50.table29', 'row50.table30', 'row50.table31']),
      new Set(['row50.table35', 'row50.table34', 'row50.table33', 'row50.table32']),
      new Set(['row50.table37', 'row50.table38', 'row50.table39', 'row50.table40']),
      new Set(['row50.table44', 'row50.table43', 'row50.table42', 'row50.table41']),
    ],
  ],
]);

export const storeToRowNumberMap = new Map<string, Set<number>>([
  ['MX-MENDEL-TST-01', new Set([0, 1, 3, 4])],
  ['US-WA-34', new Set([0, 1, 3, 4])],
  ['MENDEL-TST-02', new Set([0, 2, 4, 6])],
  ['US-CA-118', new Set([0, 2, 4, 6])],
  ['US-AZ-3', new Set([0, 2, 4])],
  ['US-CA-133', new Set([0, 2, 4])],
  ['HDNI-TST-UFF-MENDEL', new Set([0, 2, 4, 6, 8])],
  ['US-NJ-37', new Set([0, 2, 4, 6, 8])],
  ['US-VA-27', new Set([0, 2, 4, 6])],
  ['US-IL-74', new Set([0, 2, 4, 6])],
  ['US-MD-18', new Set([0, 2, 4, 6])],
  ['US-PA-22', new Set([0, 2, 4, 6])],
  ['US-IL-75', new Set([0, 2, 4])],
  ['US-NJ-45', new Set([0, 2, 4])],
  ['US-CA-194', new Set([0, 2, 4, 6])],
]);

export const storeToIncreasingOrderRowMap = new Map<string, Set<number>>([
  ['MX-MENDEL-TST-01', new Set([1, 4])],
  ['US-WA-34', new Set([1, 4])],
  ['MENDEL-TST-02', new Set([1, 3, 5, 7])],
  ['US-CA-118', new Set([1, 3, 5, 7])],
  ['US-AZ-3', new Set([1, 2, 4])],
  ['US-CA-133', new Set([1, 2, 4])],
  ['HDNI-TST-UFF-MENDEL', new Set([1, 2, 4, 6, 8])],
  ['US-NJ-37', new Set([1, 2, 4, 6, 8])],
  ['US-VA-27', new Set([0, 2, 4, 6])],
  ['US-IL-74', new Set([0, 2, 4, 6])],
  ['US-MD-18', new Set([0, 2, 4, 6])],
  ['US-PA-22', new Set([0, 2, 4, 6])],
  ['US-IL-75', new Set([1, 3, 5])],
  ['US-NJ-45', new Set([0, 2, 4])],
  ['US-CA-194', new Set([0, 2, 4, 6])],
]);

export const storeToRowNumberToGroupLabelMap = new Map<string, Map<number, string>>([
  [
    'MX-MENDEL-TST-01',
    new Map([
      [0, 'Group4'],
      [1, 'Group3'],
      [3, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'US-WA-34',
    new Map([
      [0, 'Group4'],
      [1, 'Group3'],
      [3, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'MENDEL-TST-02',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
  [
    'US-CA-118',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
  [
    'US-AZ-3',
    new Map([
      [0, 'Group3'],
      [2, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'US-CA-133',
    new Map([
      [0, 'Group3'],
      [2, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'HDNI-TST-UFF-MENDEL',
    new Map([
      [0, 'Group5'],
      [2, 'Group4'],
      [4, 'Group3'],
      [6, 'Group2'],
      [8, 'Group1'],
    ]),
  ],
  [
    'US-NJ-37',
    new Map([
      [0, 'Group5'],
      [2, 'Group4'],
      [4, 'Group3'],
      [6, 'Group2'],
      [8, 'Group1'],
    ]),
  ],
  [
    'US-VA-27',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
  [
    'US-IL-74',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
  [
    'US-MD-18',
    new Map([
      [0, 'Group3'],
      [2, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'US-PA-22',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
  [
    'US-IL-75',
    new Map([
      [0, 'Group3'],
      [2, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'US-NJ-45',
    new Map([
      [0, 'Group3'],
      [2, 'Group2'],
      [4, 'Group1'],
    ]),
  ],
  [
    'US-CA-194',
    new Map([
      [0, 'Group4'],
      [2, 'Group3'],
      [4, 'Group2'],
      [6, 'Group1'],
    ]),
  ],
]);
